module.exports = require('./src/components/TreeVis.jsx');